import React, { FC } from 'react';
import HeadComponent from '@/components/HeadComponent/HeadComponent';
import FooterComponent from '@/components/FooterComponent';
import styles from './CheckoutFailed.module.scss';
import { useTranslation } from 'react-i18next';
import { getParameters } from '@/utils/mainUtils';
import { useHistory } from 'react-router-dom';

const CheckoutFailed: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = getParameters();
  const reason = params.reason ?? params.message ?? '';
  const retryUrl = params.retryUrl ?? params.retry_url ?? '';

  const handleClose = () => {
    if (window.opener) {
      try {
        window.close();
      } catch {
        history.push('/home');
      }
    } else {
      history.push('/home');
    }
  };

  const handleRetry = () => {
    if (retryUrl) {
      try {
        window.location.href = decodeURIComponent(retryUrl);
      } catch {
        window.location.reload();
      }
    } else {
      window.location.reload();
    }
  };

  return (
    <div className={styles.root}>
      <HeadComponent isHideHome />
      <div className={styles.rootContent}>
        <div className={styles.content}>
        <div className={styles.iconWrap}>
          <div className={styles.iconRing} />
          <div className={styles.iconRingInner} />
          <div className={styles.iconCircle}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.xIcon}>
              <path d="M12 12L28 28M28 12L12 28" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </div>
        </div>
        <h1 className={styles.title}>{t('Payment Failed')}</h1>
        <p className={styles.subtitle}>
          {reason || t('Your payment could not be completed. Please try again or use another payment method.')}
        </p>
        <div className={styles.actions}>
          {retryUrl && (
            <button type="button" className={styles.retryBtn} onClick={handleRetry}>
              {t('Retry')}
            </button>
          )}
          <button type="button" className={styles.closeBtn} onClick={handleClose}>
            {t('Exit')}
          </button>
        </div>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
};

export default CheckoutFailed;
